import type { RefObject } from "react";
import type { ActiveRunSummary, AskUserQuestionAnswer, Message, ReferenceItem, RunDetail } from "../../api/types.js";
import { ActiveRunPlaceholder } from "./ActiveRunPlaceholder.js";
import { ChatThread } from "./ChatThread.js";
import { WelcomePanel } from "./WelcomePanel.js";

export function ChatStage({
  threadRef,
  isWelcome,
  isSessionLoading,
  messages,
  citationSources,
  referencePoolTotalCount,
  expandedActivityMessageId,
  setExpandedActivityMessageId,
  onOpenCitation,
  onOpenMessageSources,
  onOpenReferencePool,
  setPrompt,
  onSubmitAskUserQuestion,
  onCancelAskUserQuestion,
  saveSourceAsAsset,
  placeholderRun = null,
  onStopActiveRun = () => undefined,
  stopPending = false
}: {
  threadRef: RefObject<HTMLDivElement | null>;
  isWelcome: boolean;
  isSessionLoading: boolean;
  messages: Message[];
  citationSources: ReferenceItem[];
  referencePoolTotalCount: number;
  expandedActivityMessageId: string | null;
  setExpandedActivityMessageId: (messageId: string | null) => void;
  onOpenCitation: (messageId: string, localIndex: number) => void;
  onOpenMessageSources: (messageId: string) => void;
  onOpenReferencePool: (messageId: string) => void;
  setPrompt: (prompt: string) => void;
  onSubmitAskUserQuestion: (message: Message, answers: AskUserQuestionAnswer[]) => void;
  onCancelAskUserQuestion: (message: Message) => void;
  saveSourceAsAsset: (source: ReferenceItem) => void;
  placeholderRun?: ActiveRunSummary | RunDetail | null;
  onStopActiveRun?: () => void;
  stopPending?: boolean;
}) {
  return (
    <div className="chat-stage" ref={threadRef}>
      {isWelcome && <WelcomePanel />}

      {isSessionLoading && (
        <div className="thread-loading" role="status" aria-live="polite">
          <span />
          <p>正在加载对话...</p>
        </div>
      )}

      {!isWelcome && !isSessionLoading && (
        <>
          <ChatThread
            messages={messages}
            citationSources={citationSources}
            referencePoolTotalCount={referencePoolTotalCount}
            expandedActivityMessageId={expandedActivityMessageId}
            setExpandedActivityMessageId={setExpandedActivityMessageId}
            onOpenCitation={onOpenCitation}
            onOpenMessageSources={onOpenMessageSources}
            onOpenReferencePool={onOpenReferencePool}
            setPrompt={setPrompt}
            onSubmitAskUserQuestion={onSubmitAskUserQuestion}
            onCancelAskUserQuestion={onCancelAskUserQuestion}
            saveSourceAsAsset={saveSourceAsAsset}
          />
          {placeholderRun && (
            <ActiveRunPlaceholder run={placeholderRun} onStop={onStopActiveRun} stopPending={stopPending} />
          )}
        </>
      )}
    </div>
  );
}
